<template>
    <div>
        <report-employee-overview-deprecated
            v-if="year==='2022'"
            :collection="'mitarbeiter_'"
            :year="year"
        />

        <report-card-base
            ref="report"
            :title="'Mitarbeiter - Übersicht Neu'"
            :icon="'mdi-form-select'"
            v-else-if="(freizeiten && employeeOverviewPublished())"
        >
            <template v-slot:header-tools>
                <v-btn
                    v-if="editable && dashboard && dashboard.campDataEditable"
                    icon
                    x-small
                    @click="edit=!edit"
                    class="mr-2"
                >
                    <v-icon
                        :class="[edit?'success--text':'']"
                    >
                        mdi-pencil
                    </v-icon>
                </v-btn>
    
                <export-dialog
                    ref="exportDialog"
                    v-if="dataRequestFinished"
                    :table="getTableString()"
                    :fileName="'MitarbeiterÜbersicht'"
                >
                    <v-btn
                        icon
                        x-small
                        @click="$refs.exportDialog.show()"
                        class="mr-2"
                    >
                        <v-icon
                            :class="[edit?'success--text':'']"
                        >
                            mdi-database-export
                        </v-icon>
                    </v-btn>
                </export-dialog>
                
                <v-btn
                    icon
                    x-small
                    @click="printTable()"
                >
                    <v-icon>
                        mdi-printer
                    </v-icon>
                </v-btn>
            </template>
            <template v-slot:content>
                <v-container fluid class="pt-1">
                    <v-row
                        align="center"
                        justify="center"
                        class="pa-2 pt-0"
                    >
                        <v-btn-toggle
                            multiple
                            v-model="visibleFreizeiten"
                            v-if="freizeiten"
                        >
                            <v-btn 
                                small
                                v-for="(freizeit, index) in activeFreizeiten" :key="index"
                            >
                                <strong>{{freizeit.name}}</strong>
                            </v-btn>
                        </v-btn-toggle>
                    </v-row>
                </v-container>

                <!-- :style='{"position":"sticky","top":"130px","z-index":"100"}' -->
                <v-row
                    class="ma-0 pa-0"
                >
                    <v-text-field 
                        prepend-inner-icon="mdi-magnify" 
                        class="mb-2" dense solo hide-details v-model="nameSearch"
                        clearable
                    />
                </v-row>

                <v-simple-table
                    ref="dataTable"
                    dense
                    class="my-table"
                    style="border:1px solid silver;"
                >
                    <thead>
                        <tr v-if="tableData">
                            <th
                                style="position:sticky; left:0; z-index:1;"
                                class="striped-odd elevation-3"
                            >
                                
                            </th>
                            <th v-for="(camp, index) in getFilteredTableData()[0].value" :key="index">
                                <v-simple-checkbox 
                                    :disabled="!edit"
                                    hide-details
                                    :color="'primary'"
                                    class="ma-0 pa-0 cb"
                                    style="display:inline;"
                                    v-if="editable"
                                    v-model="freizeiten[index].mitarbeiter_planung_freigeben"
                                    @click="publishEmployeeRegistration(freizeiten[index])"
                                >
                                </v-simple-checkbox>
                                {{camp.key}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(position, rowIndex) in getFilteredTableData()" :key="rowIndex"
                            :class="rowIndex%2===0 ? 'striped' : ''"
                        >
                            <td 
                                style="max-width:160px; position:sticky; left:0; z-index:1; overflow:initial;"
                                :class="rowIndex%2===0 ? 'striped' : 'striped-odd'"
                                class="elevation-3 pl-1 pr-1 pt-0 pm-0"
                            >
                                <strong>{{position.label}}</strong>
                                
                            </td>
                            
                            <td nowrap v-for="(person, colIndex) in position.value" :key="colIndex"
                                :class="person.disabled?'grey lighten-2':''"  
                                style="border-left:1px solid silver; padding-top:6px;"
                                :style="{'border':includesFilter(person, nameSearch)?'1px solid red':''}"
                            >
                               <!-- {{position.disabled}} -->
                                <v-hover v-slot="{ hover }">
                                    <div style="position:relative; width:100%; height:100%;">
                                        <!-- <v-tooltip bottom :disabled="!person.value"> -->
                                        <v-menu
                                            :disabled="!person.value"
                                            bottom
                                            offset-y
                                            :close-on-content-click="false"
                                        >
                                            <!-- <span v-if="person.value"> -->
                                                
                                            <v-list style="background-color:#000000cc;"
                                                dense
                                            >
                                                

                                                <div
                                                    class="d-flex justify-center"
                                                    v-for="(item, index) in hoverData" :key="index" 
                                                >   
                                                    <div v-if="item.type && person.value">
                                                        <img style="border-radius: 10px; max-width:128px; max-height:128px;" :src="person.value[item.fields[0]]" />
                                                    </div>
                                                    <v-list-item 
                                                        v-else-if="
                                                            (item.condition === undefined)||
                                                            (person.value &&
                                                            (item.condition.op === '_eq' ? person.value[item.condition.key] === item.condition.value : person.value[item.condition.key] !== item.condition.value))
                                                        "
                                                        class="white--text ma-0">
                                                            <v-icon class="mr-2" size="16" color="white">{{item.icon}}</v-icon>
                                                            <span 
                                                                v-for="field in item.fields" :key="field"
                                                            >  
    
                                                                <span v-if="person.value">
                                                                    {{ field===','?',':person.value[field]}}
                                                                    <span>&nbsp;</span>
                                                                </span>
                                                            </span>
                                                            <v-spacer></v-spacer>
                                                            <v-btn
                                                                color="grey darken-1" 
                                                                icon
                                                                @click="copyToClipboard(person, item.fields)"
                                                            >
                                                                <v-icon>mdi-content-copy</v-icon>
                                                            </v-btn>
                                                    </v-list-item>
                                                </div>
                                                <v-list-item
                                                    v-if="person.value"
                                                >
                                                    <v-btn :href="'mailto:'+person.value.email" target="_blank" class="primary" block><v-icon>mdi-email-arrow-right</v-icon>Email senden</v-btn>
                                                </v-list-item>
                                                <v-list-item
                                                    v-if="person.value"
                                                >
                                                    <v-btn :href="'tel:'+person.value.mobil_telefon" target="_blank" class="primary" block><v-icon>mdi-phone</v-icon>Anrufen</v-btn>
                                                </v-list-item>
                                            </v-list>
                                            
                                            <template v-slot:activator="{ on, attrs }">
                                                
                                                <span dark v-bind="attrs" v-on="on">
                                                    
                                                    <span v-if="person.value && !edit">
                                                        <v-icon v-if="person.value.status_person_icon" :class="person.value.status_person_icon.color+'--text'">
                                                            {{person.value.status_person_icon.icon}}
                                                        </v-icon>
                                                        <span :class="hover?'font-weight-bold':''">
                                                            {{person.value.vorname}} {{person.value.nachname}}
                                                        </span>
                                                        
                                                        <!-- <v-btn
                                                            v-show="hover"
                                                            x-small
                                                            icon
                                                            text
                                                            plain
                                                            class="ma-0 pa-0"
                                                            style="position:absolute;right:-10px;"
                                                        >
                                                                <v-icon size="20">mdi-eye</v-icon>
                                                        </v-btn>         -->
                                                    </span>
    
                                                    

                                                    <span v-else-if="edit && !person.disabled">
                                                        <v-btn
                                                            v-show="hover"
                                                            style="position:absolute; right:-10px;"
                                                            v-if="(colIndex !== editedCell.colIndex || rowIndex !== editedCell.rowIndex) && person.value"
                                                            icon
                                                            x-small
                                                            @click="clearPosition(position.value[colIndex], rowIndex, colIndex)"
                                                        >
                                                            <v-icon>mdi-close</v-icon>
                                                        </v-btn>
                                                        <v-btn
                                                            v-show="hover"
                                                            v-if="(colIndex !== editedCell.colIndex || rowIndex !== editedCell.rowIndex) && person.value === undefined"
                                                            x-small
                                                            block
                                                            text
                                                            plain
                                                            class="ma-0 pa-0"
                                                            @click="editPosition(rowIndex, colIndex); openAutoComplete()"
                                                        >
                                                            <v-icon size="20">mdi-pencil</v-icon>
                                                        </v-btn>
    
                                                        <v-autocomplete 
                                                            ref="autocomplete"
                                                            dense
                                                            hide-details
                                                            v-if="colIndex === editedCell.colIndex && rowIndex === editedCell.rowIndex"
                                                            :items="peopleData"
                                                            v-model="position.value[colIndex].value"
                                                            :item-text="getPersonSearchText"
                                                            :item-value="(item)=>{return item}"
                                                            @change="savePosition(position.value[colIndex], rowIndex, colIndex)"
                                                            @blur="editedCell.rowIndex=undefined;editedCell.colIndex=undefined;"
                                                        >  
                                                            <template v-slot:append>
                                                                <v-btn
                                                                    icon
                                                                    fab
                                                                    x-small
                                                                    @click="clearPosition(position.value[colIndex], rowIndex, colIndex)"
                                                                >
                                                                    <v-icon>mdi-close</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <template v-slot:item="{item}">
                                                                <v-list class="pa-0 ma-0" dense>
                                                                    <v-list-item dense class="ma-0 pa-0">
                                                                        <v-icon :color="hasPositionAlread(item)? 'silver' : 'primary'">mdi-account</v-icon>{{item.vorname}} {{item.nachname}}
                                                                    </v-list-item>
                                                                    <span class="ma-0 pa-0" style="font-size:10px;" v-for="(freizeit, key) in item.mitarbeiter_wunsch" :key="key">
                                                                        <span
                                                                            class="ma-0 pa-0"
                                                                            v-for="(wish, wishKey) in freizeit" :key="wishKey"
                                                                        >   
                                                                            <v-list-item 
                                                                                v-if="wish"
                                                                                dense style="max-height:10px;"
                                                                                class="ma-0 pa-0"
                                                                            >
                                                                                {{key}} - {{wishKey=='wish1'?'Wunsch 1':'Wunsch 2'}} - {{wish}}
                                                                            </v-list-item>
                                                                        </span>
                                                                    </span>
                                                                </v-list>
                                                                
    
                                                            </template>
                                                        </v-autocomplete>
                                                        <span v-else-if="person.value">
                                                            
                                                            <v-icon v-if="person.value.status_person_icon" :class="person.value.status_person_icon.color+'--text'">
                                                                {{person.value.status_person_icon.icon}}
                                                            </v-icon>
                                                            {{person.value.vorname}} {{person.value.nachname}}
                                                        </span>
                                                    </span>
                                                    
                                                </span>
                                            </template>
                                        <!-- </v-tooltip> -->
                                        </v-menu>
                                    </div>
                                </v-hover>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </template>
        </report-card-base>
    </div>
</template>

<script>
import ExportDialog from '../../../components/ExportDialog.vue';
import ReportCardBase from './ReportCardBase.vue'
import ReportEmployeeOverviewDeprecated from './ReportEmployeeOverviewDeprecated.vue';
export default {
    components:{
        ReportCardBase,
        ExportDialog,
        ReportEmployeeOverviewDeprecated
    },
    inject:[
        "dashboard",
        "app"
    ],
    async created(){
        if(this.data === undefined){
            this.statusPersonDisplayOptions = await this.getStatusOptions();
        }
        await this.requestData(true);

        setTimeout(()=>{
            this.dataRequestFinished = true;
        },100);
    },
    props:{
        collection:String,
        year:String,
        data:{type:Object, default:undefined},
        editable:{type:Boolean, default:true}
    },
    data(){
        return {
            visibleFreizeiten:undefined,
            freizeiten:undefined,
            tableData:undefined,
            peopleData:undefined,
            nameSearch:"",
            edit:false,
            editedCell:{rowIndex:undefined, colIndex:undefined},
            statusPersonDisplayOptions:[],
            hoverData:[
                {icon:'mdi-account', fields:['passfoto'], type:'img'},
                {icon:'mdi-email', fields:['email']}, 
                {icon:'mdi-cellphone', fields:['mobil_telefon']}, 
                {icon:'mdi-map-marker', fields:['strasse',',','plz','ort']}, 
                {icon:'mdi-church', fields:['gemeinde'], condition:{key:'gemeinde',op:'_neq',value:'andere Gemeinde'}}, 
                {icon:'mdi-church', fields:['meine_gemeinde'], condition:{key:'gemeinde',op:'_eq',value:'andere Gemeinde'}}, 
                
            ],
            dataRequestFinished:false,
        }
    },
    computed:{

        collectionWithYear(){
            return this.collection + this.year
        },
        activeFreizeiten(){
            let freizeiten = [];
            for(let freizeit of this.freizeiten){
                if(freizeit.mitarbeiter_planung_freigeben || this.editable){
                    freizeiten.push(freizeit)
                }
            }
            return freizeiten;
        },
        visibleFreizeitKeys(){
            let visibleKeys = []
            if(this.visibleFreizeiten){
                for(let index of this.visibleFreizeiten){
                    visibleKeys.push(this.freizeiten[index].name);
                }
            }
            return visibleKeys;
        }
    },
    methods:{
        hasContactsAPI(){
            const supported = "contacts" in navigator && "ContactsManager" in window;
            return supported;
        },
        addContact(person){
            console.log(person)
            navigator.permissions.query({name: 'contacts'}).then(function(result) {
            if (result.state === 'granted') {
                console.log("permission granted")
                // Permission granted, proceed with using the Web Contacts API
            } else if (result.state === 'prompt') {
                
                console.log("prompt permission")
                // User hasn't yet granted or denied permission, show a prompt to request permission
                navigator.contacts.requestPermission().then(function() {
                // Permission granted, proceed with using the Web Contacts API
                }, function() {
                // Permission denied, handle accordingly
                });
            } else if (result.state === 'denied') {
                
                console.log("permission denied")
                // Permission denied, handle accordingly
            }
            });
        },
        async copyToClipboard(person, fields){
            let string = ""
            for(let field of fields){
                if(person.value){
                    if (field === ","){
                        string += field+" "
                    }else{
                        string += person.value[field]
                    }
                }
            }

            // create a temporary input element
            const input = document.createElement('input');
            input.setAttribute('value', string);
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            this.app.showNotification(string + " wurde in die Zwischenablage kopiert.", undefined, "success")
        },
        includesFilter(personData, filter){
            if(filter === ""){
                return false
            }
            if (personData.value && personData.value.vorname){

                let vorname = personData.value.vorname.toLowerCase().includes(filter.toLowerCase());
                let nachname = personData.value.nachname.toLowerCase().includes(filter.toLowerCase());
                return vorname || nachname;
            }
            return false
        },
        hasPositionAlread(person){
            if(person.mitarbeiter_position){
                for(let freizeit of Object.keys(person.mitarbeiter_position)){
                    if(person.mitarbeiter_position[freizeit].position !== null){
                        return true
                    }
                }
            }
            return false
        },  
        employeeOverviewPublished(){
            if(this.editable){
                return true;
            }
            for(let freizeit of this.freizeiten){
                if(freizeit.mitarbeiter_planung_freigeben){
                    return true;
                }
            }
            return false;
        },
        getVisibleFreizeiten(){
            let visibleFreizeiten = []
            for(let i=0; i<this.freizeiten.length; i++){
                let freizeit = this.freizeiten[i];
                if(freizeit.mitarbeiter_planung_freigeben || this.editable){
                    visibleFreizeiten.push(i);
                }
            }
            return visibleFreizeiten;
        },
        publishEmployeeRegistration(freizeit){
            let url = "/items/freizeit/"+freizeit.id;
            let payload = {
                mitarbeiter_planung_freigeben:freizeit.mitarbeiter_planung_freigeben
            }
            this.$network.requestPatch(url, payload);
        },
        getFilteredTableData(){
            let filteredTable = []
            if(this.tableData){
                for(let position of this.tableData){
                    let positionFiltered = JSON.parse(JSON.stringify(position));
                    positionFiltered.value = [];
                    for(let freizeit of position.value){
                        if(this.visibleFreizeitKeys.includes(freizeit.key)){
                            positionFiltered.value.push(freizeit);
                        }
                    }
                    filteredTable.push(positionFiltered);
                }
            }
            return filteredTable;
        },
        getTableString(){
            if(this.$refs.dataTable){
                return this.$refs.dataTable.$el.getElementsByTagName("TABLE")[0];
            }
            return undefined;
        },
        getPersonStatus(status){
            for(let option of this.statusPersonDisplayOptions){
                if (option.name === status){
                    return option;
                }
            }
            return undefined;
        },
        async getStatusOptions(){
            let field = await this.$network.getFieldData(this.collectionWithYear, "status_person");
            let status = field.meta.display_options.status;
            return status
        },
        openAutoComplete(){
            this.$nextTick(()=>{
                this.$nextTick(()=>{
                    this.$refs.autocomplete[0].focus();
                    this.$refs.autocomplete[0].activateMenu();
                })
            })
        },
        getPersonSearchText(item){
            let str = item.vorname + " " + item.nachname;

            for(let freizeitKey in item.mitarbeiter_wunsch){
                let freizeit = item.mitarbeiter_wunsch[freizeitKey];
                for(let wishKey in freizeit){
                    let wish = freizeit[wishKey];
                    if(wish){
                        str += " " + freizeitKey + " " + wish
                    }
                }
            }
            return str;
        },
        async clearPosition(item, rowIndex, colIndex){
            this.savePosition(item, rowIndex, colIndex, true)
        },
        async savePosition(item, rowIndex, colIndex, clear=false){
            colIndex
            let person = item.value;
            let camp = item.key;
            let position = this.tableData[rowIndex].key
            let payload = undefined;

            if(person && !person.mitarbeiter_position){
                person.mitarbeiter_position = {}
                for(let freizeit of this.freizeiten){
                    person.mitarbeiter_position[freizeit.name] = {position:null};
                }
            }

            if(person){
                person.mitarbeiter_position[camp] = {position:clear?null:position};
                payload = {mitarbeiter_position : person.mitarbeiter_position};
                
                let result = await this.$network.requestPatch("/items/"+this.collectionWithYear+"/"+person.id, payload);
                if(result.status === 200){
                    this.editedCell.rowIndex = undefined;
                    this.editedCell.colIndex = undefined;
                }
            }
            this.requestData()
        },
        editPosition(rowIndex, colIndex){
            this.editedCell.rowIndex = rowIndex;
            this.editedCell.colIndex = colIndex;
        },
        async requestData(initialLoad=false){
            if(initialLoad){
                if(this.$refs.report){
                    this.$refs.report.setLoading(true);
                }
            }
            let peopleData = undefined;
            if(this.data === undefined){
                let url = "/items/"+this.collectionWithYear+"?limit=-1"
                url += '&filter={"_or":[{"status_person":{"_in":["Bestätigt","Angemeldet","Warteliste"]}}]}'
                url += "&fields=id,passfoto,vorname,nachname,status_person,geschlecht,email,gemeinde,meine_gemeinde"
                url += ",mitarbeiter_wunsch,mitarbeiter_position"
                url += ",mobil_telefon,status_person"
                url += ",strasse,plz,ort"

                let result = await this.$network.requestGet(url);
                if(result.status === 200){
                    peopleData = result.data.data;
                    this.peopleData = result.data.data;
                }
                url = "/items/camp?fields=freizeit.*&filter[jahr][_eq]="+this.year.toString();
                result = await this.$network.requestGet(url);
                if(result.status === 200){
                    this.freizeiten = result.data.data[0].freizeit;
                }
            }else{
                this.peopleData = this.data.data_contacts;
                peopleData = this.data.data_contacts;
                this.freizeiten = this.data.data_camp.freizeit;
            }
            if(peopleData){
                this.tableData = this.extractDisplayData(peopleData, this.freizeiten);
            }
            if(!this.visibleFreizeiten){
                this.visibleFreizeiten = this.getVisibleFreizeiten();
            }
            if(this.$refs.report){
                this.$refs.report.setLoading(false);
            }
        },
        getGenderName(string, gender){
            if(gender === "male"){
                return string.split("/")[0];
            }else if(gender === "female"){
                return string.split("/")[0] + string.split("/")[1];
            }
        },
        extractDisplayData(peopleData, freizeiten){
            let tableData = []
            peopleData = peopleData.slice(0);
            // Build tableData skeleton with empty values
            for(let camp of freizeiten){
                let campPositions = []
                if(freizeiten[0].mitarbeiter_positionen){
                    
                    for(let i=0; i<freizeiten[0].mitarbeiter_positionen.length; i++){
                        
                        let position = freizeiten[0].mitarbeiter_positionen[i];
                        if(position.count){
                            for(let j=0; j<position.count; j++){
                                let tablePosition = {
                                    key:position.position,
                                    label:position.position,
                                    value:undefined
                                }
                                if(j > 0){tablePosition.label = "";}
                                if(j > camp.mitarbeiter_positionen[i].count-1){tablePosition.disabled=true;}
                                else{tablePosition.disabled=false;}
                                campPositions.push(tablePosition)
                            }
                        }
                        if(position.count_female){
                            for(let j=0; j<position.count_female; j++){
                                let tablePosition = {
                                    key:position.position,
                                    label:this.getGenderName(position.position, "female"),
                                    gender:"weiblich",
                                    value:undefined
                                }
                                if(j > 0){tablePosition.label = "";}
                                if(j > camp.mitarbeiter_positionen[i].count_female-1){tablePosition.disabled=true;}
                                else{tablePosition.disabled=false;}
                                campPositions.push(tablePosition)
                            }
                        }
                        if(position.count_male){
                            for(let j=0; j<position.count_male; j++){
                                let tablePosition = {
                                    key:position.position,
                                    label:this.getGenderName(position.position, "male"),
                                    gender:"männlich",
                                    value:undefined
                                }
                                if(j > 0){tablePosition.label = "";}
                                if(j > camp.mitarbeiter_positionen[i].count_male-1){tablePosition.disabled=true;}
                                else{tablePosition.disabled=false;}
                                campPositions.push(tablePosition)
                            }
                        }
                    }
                }
                tableData.push({key:camp.name, value:campPositions});
            }
            // fill tableData with persons
            let i = -1;
            for(let camp of tableData){
                i++;
                let j = -1
                var filledPositions = [];
                for(let position of camp.value){
                    j++;
                    for(let person of peopleData){
                        if(["Abgemeldet", "Absage"].includes(person.status_person) === false){
                            if(person.mitarbeiter_position){
                                let personPosition = person.mitarbeiter_position[camp.key].position;
                                if(personPosition && position.key === personPosition){
                                    if(tableData[i].value[j].value === undefined && !filledPositions.includes(person)){
                                        if(!position.gender || person.geschlecht === position.gender){
                                            person.status_person_icon = this.getPersonStatus(person.status_person);
                                            tableData[i].value[j].value = person;
                                            filledPositions.push(person);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            // transpose data array for flipped visualization
            let tableDataTransposed = []
            for(let i=0; i<tableData.length; i++){
                let camp = tableData[i]
                for(let j=0; j<camp.value.length; j++){
                    let position = camp.value[j];
                    if(tableDataTransposed[j] === undefined){
                        tableDataTransposed[j] = {
                            key:position.key,
                            label:position.label,
                            value:[]
                        }
                    }
                    tableDataTransposed[j].value.push({
                        key:camp.key,
                        value:position.value,
                        disabled:position.disabled
                    })
                }
            }
            return tableDataTransposed;
        },

        printTable(){
            let table = this.$refs.dataTable.$el.getElementsByTagName("TABLE")[0];
            let str = ""
            str="<body style='-webkit-print-color-adjust: exact;'>"
            str += `<h4 style='margin-bottom:5px; font-family:Arial;'>Espelcamp - Mitarbeiter Übersicht ${this.year}</h4>`
            str += "<table style='page-break-inside: auto; width:100%; font-family:Arial; border:1px solid silver; border-collapse: collapse;'>"
            
                // create table header    
            str += "<thead>"
            str += "<tr>"
            for(let i in table.rows[0].cells){
                let cell = table.rows[0].cells[i];
                str += `<th style='font-size:10px; padding:5px; text-align:left;'>${cell.innerText ? cell.innerText : ""}</th>`
            }
            str += "</tr>"
            str += "</thead>"
            
            // create table content    
            str += "<tbody>"
            for(let i in table.rows){
                let row = table.rows[i];
                if(i%2 === 0){
                    str += "<tr>"
                }else{
                    str += "<tr style='background-color:rgba(0, 0, 0, .03);'>"
                }
                for(let j in row.cells){
                    let cell = row.cells[j];
                    if(j > 0 && cell.innerText !== undefined && i>0){
                        str += "<td height='20px' style='font-size:10px; padding:4px; border:1px solid silver; border-collapse: collapse;'>"
                        str += cell.innerText;
                        str += "</td>"
                    }else if(cell.innerText !== undefined && i>0){
                        str += "<td width='100px' height='20px' style='font-size:10px; padding:4px; border:1px solid silver; border-collapse: collapse; background-color:rgba(0, 0, 0, .05);'>"
                        str += cell.innerText;
                        str += "</td>"
                    }
                }
                str+="</tr>"
            }
            str += "</tbody>"
            str += "</table>"
            str += "</body>"
            let newWin= window.open("");
            newWin.document.write(str);
            newWin.print();
            newWin.close();
        }
    }
}
</script>

<style scoped>
    .striped {
        background-color: #fafafa;
    }
    .striped-odd{
        background-color: #ffffff;
    }
    .capitalize {
        text-transform: capitalize;
    }
    .custom-table{
        border-right:1px solid silver;
    }
    .custom-row{
        border-radius: 0;
        border-bottom:1px solid silver;
    }
    .custom-col{
        border-bottom:1px solid silver;
    }
</style>